function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuote = function SvgIconQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.591 15.844V.292H.631v15.552h3.96Zm9.072 0V.292h-3.96v15.552h3.96Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgIconQuote;